import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { reset, setAllUsers, setTotal, setLoading } from './actions';

const usersReducer = handleActions(
  {
    [setAllUsers.toString()]: (_, { payload: users }) => users,
    [reset.toString()]: () => []
  },
  []
);

const totalReducer = handleActions(
  {
    [setTotal.toString()]: (_, { payload: total }) => total,
    [reset.toString()]: () => 0
  },
  0
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  users: usersReducer,
  total: totalReducer,
  loading: loadingReducer
});
